const state = {
  dialogInteressado: false,
  dialogAssunto: false,
  dialogGlossario: false,

  listaTipoDocumento: [],
  listaUnidadesProcedencia: [],
  listaTiposInteressado: [],
  listaEntidadeInteressada: [],
  listaAssunto: [],
  listaAssuntoNivel1: [],
  listaItensGlossario: [],
  listaItensCriacao: [],

  tipoDocumento: undefined,
  unidadeProcedencia: undefined,
  tipoInteressado: undefined,
  interessado: undefined,
  assunto: undefined,
  resumoAssunto: undefined,
  urgente: false,
  motivoUrgencia: undefined,
  documentoOrigem: undefined,
  emitente: undefined,
  dataDocumentoOrigem: undefined,
  dataRecebimentoDocumentoOrigem: undefined,
  observacao: undefined,

  documento: undefined,
  buscandoDocumentoOrigem: false
}

export default state
